// eslint-disable-next-line import/no-cycle
import { 
  GetMailList, 
  SendMailAction, 
  SendGroupMailAction,
  GetAdminMail,
  GetAdminMailItem,
  PerformAdminAction,
  PerformAdminGroupAction,
  GetAdminGroupMail,
  GetAdminGroupMailItem,
  ChangeAdminGroupMail,
  DeleteAdminGroupMail,
  CreateAdminGroupMail,
  FindPrivateMailboxes,
  GetFreePMBs,
  CreateNewMailItem,
  EditMailItem,
  DeleteMailItem,
  CreateBulkMailItems,
  PublishBulkMail,
  RemoveBulkMail,
  SetForwardingAddress,
  SetGroupForwardingAddress,
  GetMailTemplates
} from '@/api/mail-list';

export const fetchMails = ({ commit, dispatch }, params) => {
  commit('CLEAR_MORE_MAILS');
  commit('MAIL_REQUEST_DISPATCH');

  return dispatch('CheckAuth', null, {root: true})
    .then(() => {
      return GetMailList(params)
        .then((list) => {
          commit('MAIL_REQUEST_SUCCESS');
          commit('CLEAR_MORE_MAILS');
          commit('SAVE_LIST', list);
        });
    })
    .catch((e) => {
      commit('MAIL_REQUEST_ERROR');
      console.log('err check auth on fetchMails', e);
    });
}

export const fetchMore = ({ commit, dispatch }, params) => {
  dispatch('CheckAuth', null, {root: true})
    .then(() => {
      GetMailList(params)
        .then((list) => {
          commit('ADD_MORE_MAILS', list.mail_items);
        });
    })
    .catch((e) => {
      console.log('err check auth on checkMore', e);
    });
}

export const mailAction = ({ commit, dispatch }, params) => {
  commit('MAIL_REQUEST_DISPATCH');
  return dispatch('CheckAuth', null, {root: true})
    .then(async () => {
      return SendMailAction(params)
        .then((mail) => {
          commit('MAIL_REQUEST_SUCCESS');
          commit('UPDATE_ACTION_MAIL', {
            id: mail.mail_item.id,
            item: mail.mail_item,
            ...params,
            undo: params.undo || false,

          });
        });
    })
    .catch((e) => {
      console.log('err check auth on mailAction', e);
    });
}

export const groupMailAction = ({ commit, dispatch }, params) => {
  return dispatch('CheckAuth', null, {root: true})
    .then(async () => {
      return SendGroupMailAction(params)
        .then((mail) => {
          commit('UPDATE_ACTION_MAIL', {
            id: mail.mail_items[0].id,
            action: params.action,
            enabled: params.toSend ? params.toSend.enabled : true,
            items: mail.mail_items,
            undo: params.undo || false
          });
        });
    })
    .catch((e) => {
      console.log('err check auth on groupMailAction', e);
    });
}

// Admin
export const getAdminList = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminMail(params)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAdminMail = ({commit, dispatch}, mail_number) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminMailItem(mail_number)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const adminMailAction = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => PerformAdminAction(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const adminMailGroupAction = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => PerformAdminGroupAction(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAdminGroupList = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminGroupMail(params)
    .then(res => {
      commit('SAVE_REMINDERS', res.reminders);

      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAdminGroupMailItem = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAdminGroupMailItem(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const changeAdminGroupMail = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => ChangeAdminGroupMail(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteAdminGroupMail = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteAdminGroupMail(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createAdminGroupMail = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateAdminGroupMail(params)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const findPMBs = ({commit, dispatch}, pattern, group_mail_enabled = false) => dispatch('CheckAuth', null, {root: true})
  .then(() => FindPrivateMailboxes(pattern, group_mail_enabled)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAvailablePMBs = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
.then(() => GetFreePMBs()
  .then(res => {
    return res;
  })
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))
)

export const createNewMail = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateNewMailItem(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const editMail = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => EditMailItem(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteMail = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteMailItem(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createBulkMail = ({dispatch}, items) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateBulkMailItems(items)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

  export const publishBulkMail = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => PublishBulkMail(params)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeBulkMail = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveBulkMail(params)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

  

export const setForwardingAddress = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SetForwardingAddress(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const setGroupForwardingAddress = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SetGroupForwardingAddress(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getMailTemplates = ({dispatch}, pmb) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetMailTemplates(pmb)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )
  